// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.appButton {
  border: none;
  border-radius: 4px;
  font-weight: 700;
  padding: 10px 28px;
  transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;
}

.appButton--primary {
  background-color: #eaa637;
  color: #172639;
}

.appButton--primary:hover,
.appButton--primary:focus {
  background-color: #172639;
  color: #eaa637;
}

.appButton--secondary {
  background-color: transparent;
  color: #172639;
  border: 1px solid #172639;
}

.appButton--secondary:hover,
.appButton--secondary:focus {
  background-color: #172639;
  color: #ffffff;
}
`, "",{"version":3,"sources":["webpack://./src/components/AppButton.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,+EAA+E;AACjF;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB","sourcesContent":[".appButton {\n  border: none;\n  border-radius: 4px;\n  font-weight: 700;\n  padding: 10px 28px;\n  transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;\n}\n\n.appButton--primary {\n  background-color: #eaa637;\n  color: #172639;\n}\n\n.appButton--primary:hover,\n.appButton--primary:focus {\n  background-color: #172639;\n  color: #eaa637;\n}\n\n.appButton--secondary {\n  background-color: transparent;\n  color: #172639;\n  border: 1px solid #172639;\n}\n\n.appButton--secondary:hover,\n.appButton--secondary:focus {\n  background-color: #172639;\n  color: #ffffff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
